// extracted by mini-css-extract-plugin
export default {"root":"DataList_root__TzrKV","title":"DataList_title__fo0R8","item":"DataList_item__MUP57","empty":"DataList_empty__hOXsX"};